import openUrl from '../openUrl';

export default function openWebView(navigator, webViewRef, url) {
    openUrl(url);
}